import React, { SVGProps } from "react";

const SvgRoof5 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 350 300"
    {...props}
  >
    <defs>
      <linearGradient
        id="roof5_svg__b"
        x1={244.346}
        y1={223.48}
        x2={217.419}
        y2={176.84}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.471} stopColor="#b4c5d3" stopOpacity={0} />
        <stop offset={1} stopColor="#b4c5d3" stopOpacity={0.35} />
      </linearGradient>
      <linearGradient
        id="roof5_svg__c"
        x1={61.22}
        y1={246.436}
        x2={114.499}
        y2={154.154}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.316} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="roof5_svg__a"
        x1={328.731}
        y1={138.318}
        x2={328.731}
        y2={112.574}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.117} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof5_svg__d"
        x1={21.399}
        y1={187.128}
        x2={21.399}
        y2={149.712}
        xlinkHref="#roof5_svg__a"
      />
      <linearGradient
        id="roof5_svg__e"
        x1={133.033}
        y1={251.43}
        x2={133.033}
        y2={225.685}
        xlinkHref="#roof5_svg__a"
      />
    </defs>
    <path fill="none" d="M0 0h350v300H0z" />
    <path
      fill="url(#roof5_svg__b)"
      d="M133.033 225.685v62.062l195.699-113.111v-62.062L133.033 225.685z"
    />
    <path
      fill="url(#roof5_svg__c)"
      d="M133.033 225.685v62.062L21.399 223.445v-73.733l50.177-20.34 61.457 96.313z"
    />
    <g fill="#6d9faf">
      <path d="M75.875 153.952v11.261l-9.362-5.393v-11.261l9.362 5.393zM87.344 160.574v11.261l-9.363-5.393V155.18l9.363 5.394zM75.875 167.439V178.7l-9.362-5.393v-11.261l9.362 5.393zM87.344 174.061v11.261l-9.363-5.393v-11.261l9.363 5.393z" />
    </g>
    <path
      fill="#237bae"
      d="M340 105.914 133.033 225.685l-62.024-96.004L278.43 10 340 105.914z"
    />
    <path
      fill="#48d7ff"
      d="M278.43 10 71.009 129.681 10 154.361l207.252-119.78L278.43 10z"
    />
    <path
      fill="#b4c5d3"
      d="M184.529 130.982v31.561l72.858-42.19v-31.56l-72.858 42.189z"
    />
    <path
      fill="#fff"
      d="M184.529 130.982v31.561l-47.641-71.025 47.641 39.464z"
    />
    <path
      fill="#309ed6"
      d="m136.888 91.518 52.34 46.569 75.654-43.805-52.339-46.569-75.655 43.805z"
    />
    <path
      fill="#255d63"
      d="M207.894 131.267v14.056l11.97-6.932v-14.056l-11.97 6.932zM222.37 122.909v14.056l11.971-6.931v-14.057l-11.971 6.932z"
    />
    <path fill="url(#roof5_svg__a)" d="M328.231 112.574h1v25.745h-1z" />
    <path fill="url(#roof5_svg__d)" d="M20.899 149.712h1v37.416h-1z" />
    <path fill="url(#roof5_svg__e)" d="M132.533 225.685h1v25.745h-1z" />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m278.43 10-61.178 24.581L10 154.361l61.009-24.68 62.024 96.004L340 105.914 278.43 10z"
    />
    <path
      fill="none"
      stroke="#002839"
      strokeMiterlimit={10}
      d="M71.43 128.909 278.43 10"
    />
    <path
      fill="none"
      stroke="#3f3f3f"
      strokeMiterlimit={10}
      d="M257.387 98.622v21.731l-72.858 42.19-47.641-71.025M184.529 161.996v-28.09"
    />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      d="m213.879 47.713 51.003 46.569-75.654 43.805-52.34-46.569"
    />
  </svg>
);

export default SvgRoof5;
